import axios from "axios";
import { BASE_URL } from "../config/config";
const Cookies = require("js-cookie");

// Create an Axios instance
const apiClient = axios.create({
  baseURL: BASE_URL,
  timeout: 50000, // 10 seconds timeout
  withCredentials: true,
});

// Function to make API calls

export const apiCall = async (method, url, data = {}, isMultipart = false) => {
  try {
    const headers = {
      "Content-Type": isMultipart ? "multipart/form-data" : "application/json",
    };

    const response = await apiClient({
      method,
      url,
      data,
      headers,
      // withCredentials: true, // Required for cookie-based auth (if used)
    });

    return {...response?.data, status: response?.status};
  } catch (error) {
    if (error?.response?.status === 403 || error?.response?.status === 401) {
      try {
         const tokenResponse = await apiClient.get(
          "access-token", // Change this path as per your backend
          {
            // headers: {
            //   Authorization: `Bearer ${refreshToken}`,
            // },
            withCredentials: true,
          }
        );

        const retryHeaders = {
          "Content-Type": isMultipart ? "multipart/form-data" : "application/json",
          // Authorization: `Bearer ${newAccessToken}`,
        };

        const retryResponse = await apiClient({
          method,
          url,
          data,
          headers: retryHeaders,
          // withCredentials: true,
        });

        return retryResponse?.data;
      } catch (refreshError) {
        localStorage.clear();
        Cookies.remove("token")
        Cookies.remove("accessToken")
        Cookies.remove("refreshToken")
        return {
          success: false,
          message: "Session expired. Please log in again.",
          data: null,
          code : refreshError?.response?.status || 401
        };
      }
    }

    return {
      success: false,
      message: error?.response?.data?.message || error?.message || "Request failed!",
      data: null,
      code : error?.response?.status || 400
    };
  }
};

export const apiGet = (url) => apiCall("get", url);
export const apiPost = (url, data, isMultipart = false) => apiCall("post", url, data, isMultipart);
export const apiPut = (url, data, isMultipart = false) => apiCall("put", url, data, isMultipart);
export const apiDelete = (url) => apiCall("delete", url);
